import { mapKeys, merge } from 'lodash';

import { AuthActionTypes, AuthUserState } from './auth.types';

const initialState = {
  id: '',
  name: '',
  email: '',
  role: undefined,
  permissions: {},
  product_type: undefined,
  production: false,
  current_account_id: '',
  loggedIn: false,
  agent_type: undefined,
  loginErrorCode: null,
  mfaPayload: null,
  loginStatus: 'idle',
  callCsrfFlag: false,
  callCsrfPayload: null
} as AuthUserState;

export type AuthState = typeof initialState;

// eslint-disable-next-line @typescript-eslint/default-param-last
const authReducer = (state = initialState, action: AuthActionTypes): AuthState => {
  switch (action.type) {
    case 'LOGIN_REQUEST': {
      return {
        ...state,
        callCsrfFlag: false,
        loginStatus: 'pending'
      };
    }

    case 'LOGIN_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loggedIn: true,
        loginErrorCode: null,
        callCsrfFlag: false,
        callCsrfPayload: null,
        loginStatus: 'resolved'
      };
    }

    case 'SET_LOGIN_ERROR_CODE': {
      return {
        ...state,
        loginErrorCode: action.payload,
        callCsrfFlag: false,
        callCsrfPayload: null,
        loginStatus: 'resolved'
      };
    }

    case 'MAKE_CSRF_CALL': {
      return {
        ...state,
        callCsrfFlag: true,
        callCsrfPayload: action.payload
      };
    }

    case 'LOGOUT_REQUEST': {
      return {
        ...state,
        callCsrfFlag: false,
        callCsrfPayload: null,
        loginStatus: 'pending'
      };
    }

    case 'LOGOUT_SUCCESS': {
      return {
        ...initialState,
        loggedIn: false,
        callCsrfFlag: false,
        callCsrfPayload: null,
        loginStatus: 'resolved'
      };
    }

    case 'SESSION_EXPIRED': {
      return {
        ...state,
        loggedIn: false,
        callCsrfFlag: false,
        callCsrfPayload: null,
        loginStatus: 'resolved'
      };
    }

    case 'UPDATE_USER_NAME': {
      return {
        ...state,
        name: action.payload
      };
    }

    case 'FILTER_PERMISSIONS':
      return {
        ...state,
        permissions: action.payload(state.permissions)
      };

    case 'UPDATE_PERMISSIONS':
      return {
        ...state,
        permissions: merge({}, state.permissions, mapKeys(action.payload))
      };

    case 'SET_PRODUCT_TYPE_SUCCESS':
      return {
        ...state,
        product_type: action.payload
      };

    case 'MFA_LOGIN':
      return {
        ...state,
        mfaPayload: action.payload
      };

    case 'MFA_CLEAR':
      return {
        ...state,
        mfaPayload: null,
        callCsrfFlag: false,
        callCsrfPayload: null,
        loginStatus: 'resolved'
      };

    default:
      return state;
  }
};

export default authReducer;
